import React from "react";

import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Navbar,
  Nav,
  Container,
  Media
} from "reactstrap";
import {connect} from "react-redux";
import { withLocalize } from "react-localize-redux";
import { Translate } from "react-localize-redux";
import * as actions from "../../store/actions/actions";
import LanguageToggle from "../language/languageToggle";
import italianLoginTranslations from "../../translations/login/it.login.json";
import englishLoginTranslations from "../../translations/login/en.login.json";
import * as Roles from "../../store/actions/roles";

class AdminNavbar extends React.Component {
  constructor(props) {
    super(props);

    this.props.addTranslationForLanguage(italianLoginTranslations, "it");
    this.props.addTranslationForLanguage(englishLoginTranslations, "en");
  }

  logOut = () => {
    this.props.logout(this.props.token)
  }
  profile = () =>{
    this.props.profilePage(this.props.username)
  }

  onLogoClick = () =>{
    this.props.history.push("/")
  }

  render() {
    let originalLogo = this.props.corporateLogo !== null ? this.props.corporateLogo.substring(this.props.corporateLogo.indexOf('data')) : null;
    let logo = Roles.isCorporateUser(this.props.role) === true ?
        <div className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
          <img alt="" onClick={this.onLogoClick} src={originalLogo} width="250" className="img-rounded"/>
        </div>
        :
        "";
    //Old Bank Logo
    // <div className="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
    //   <img alt="" onClick={this.onLogoClick} src={this.props.bankLogo} width="250" className="img-rounded"/>
    // </div>
    return (
        <>
          <Navbar className="navbar-top navbar-dark" expand="md" id="navbar-main">
            <Container fluid>
              <div className={"row"} style={{width:"inherit"}}>
                <div className={"col-8"}>
                  {logo}
                </div>
                <div className={"col-2"} style={{wordWrap:"break-word"}}>
                  <Nav className="d-none d-md-flex" navbar style={{marginLeft:"-10em"}}>
                    <UncontrolledDropdown nav>
                      <DropdownToggle className="pr-0" nav>
                        <Media className="align-items-center">
                    <span className="avatar avatar-sm rounded-circle">
                      <img
                          alt="..."
                          src={
                            this.props.imageString !== '' && this.props.imageString !== null  ? this.props.imageString :
                                require("../../assets/img/theme/defaultprofile.png")
                          }
                      />
                    </span>
                          <Media className="ml-2 d-none d-lg-block">
                      <span className="mb-0 text-sm font-weight-bold">
                        {this.props.fullName}
                      </span>
                          </Media>
                        </Media>
                      </DropdownToggle>
                      <DropdownMenu className="dropdown-menu-arrow" right>
                        <DropdownItem className="noti-title" header tag="div">
                          <h6 className="text-overflow m-0">
                            <Translate id="login.welcome"/>
                          </h6>
                        </DropdownItem>
                        <DropdownItem onClick={this.profile}>
                          <i className="ni ni-single-02" />
                          <span>
                      <Translate id="login.profile"/>
                    </span>
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem onClick={this.logOut}>
                          <i className="ni ni-user-run" />
                          <span>
                      <Translate id="login.logout"/></span>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </Nav>
                </div>
                <div className={"col-2"}>
                  <LanguageToggle  />
                </div>
              </div>
            </Container>
          </Navbar>
        </>
    );
  }
}

const mapStateToProps = state => {
  return {
    fullName: state.authentication.authenticatedUser.fullName,
    username:state.authentication.authenticatedUser.username,
    authenticated: state.authentication.authenticatedUser.authenticated,
    imageString:state.profile.profile.imageString,
    token: state.authentication.authenticatedUser.token,
    bankLogo:state.authentication.authenticatedUser.bankLogo,
    corporateLogo:state.authentication.authenticatedUser.corporateLogo,
    role:state.authentication.authenticatedUser.role
  }
}
const mapDispatchToProps = dispatch => {
  return {
    logout: (data) => dispatch({ type: actions.AUTHENTICATION_LOGOUT_REQUEST, value: data }),
    profilePage: (username) => dispatch({ type: actions.PROFILE_PAGE_MENU_REQUEST, value: username }),

  }
}

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(AdminNavbar));
